// extracted by mini-css-extract-plugin
export var icon = "_wv-0";